export class InternalEquipmentFolder {
    id: number;
    name: string;

    idFather: number;
    nameFather: string;

    equipments: number[] = [];
}